<template>
    <div class="banner_wrapper">
        <div class="sprite_wrapper" v-bind:style="{ width:width, height:height }">
            <div class="pole_div"></div>
            <div class="icon_div" v-bind:class="[iconName, iconColor]"></div>
            <div class="banner_div" v-bind:class="[bannerName, bannerColor]"></div>
        </div>
        <div style="clear:both;"></div>
    </div>
</template>

<script>

    // let symbolColor="16761643";
    // let shapeColor="11862016";
    // let symbolId="guildicon09";
    // let shapeId="guildbanner08";


    export default {
        name: "elv-banner-icon",
        props: {
            'sprite_wrapper': {required:false},
            'width': {default:'120px', required:false},
            'height': {default:'120px', required:false},
            'banner': {required:true},
        },
        data() {
            return {
            };
        },
        computed: {
            bannerColor: {
                get: function() {
                    if(this.banner.shapeColor == '4802889' ) {
                        return "banner_black";
                    }
                    else if(this.banner.shapeColor == '16777215'){
                        return "banner_grey";
                    }
                    else if(this.banner.shapeColor == '4696116'){
                        return "banner_green";
                    }
                    else if(this.banner.shapeColor == '16761643'){
                        return "banner_gold";
                    }
                    else if(this.banner.shapeColor == '11862016'){
                        return "banner_red";
                    }
                    else if(this.banner.shapeColor == '14641694'){
                        return "banner_orange";
                    }
                    else if(this.banner.shapeColor == '5744869'){
                        return "banner_cyan";
                    }
                    else if(this.banner.shapeColor == '869548'){
                        return "banner_blue";
                    }
                    else if(this.banner.shapeColor == '9131719'){
                        return "banner_purple";
                    }
                    else if(this.banner.shapeColor == '15025865'){
                        return "banner_violet";
                    }
                    else {
                        console.log("matched the default shape color")
                        return "banner_grey"; /* default */
                    }
                }
            },
            iconColor: {
                get: function() {
                    if(this.banner.symbolColor == '4802889' ) {
                        return "banner_black";
                    }
                    else if(this.banner.symbolColor == '16777215'){
                        return "banner_grey";
                    }
                    else if(this.banner.symbolColor == '4696116'){
                        return "banner_green";
                    }
                    else if(this.banner.symbolColor == '16761643'){
                        return "banner_gold";
                    }
                    else if(this.banner.symbolColor == '11862016'){
                        return "banner_red";
                    }
                    else if(this.banner.symbolColor == '14641694'){
                        return "banner_orange";
                    }
                    else if(this.banner.symbolColor == '5744869'){
                        return "banner_cyan";
                    }
                    else if(this.banner.symbolColor == '869548'){
                        return "banner_blue";
                    }
                    else if(this.banner.symbolColor == '9131719'){
                        return "banner_purple";
                    }
                    else if(this.banner.symbolColor == '15025865'){
                        return "banner_violet";
                    }
                    else {
                        return "banner_grey"; /* default */
                    }
                }
            },
            bannerName: {
                get: function() {
                    if( this.banner.shapeId === 'guildbanner01' ) {
                        return "banner_one";
                    }
                    else if( this.banner.shapeId === 'guildbanner02'){
                        return "banner_two";
                    }
                    else if( this.banner.shapeId === 'guildbanner03'){
                        return "banner_three";
                    }
                    else if( this.banner.shapeId === 'guildbanner04'){
                        return "banner_four";
                    }
                    else if( this.banner.shapeId === 'guildbanner05'){
                        return "banner_five";
                    }
                    else if( this.banner.shapeId === 'guildbanner06'){
                        return "banner_six";
                    }
                    else if( this.banner.shapeId === 'guildbanner07'){
                        return "banner_seven";
                    }
                    else if( this.banner.shapeId === 'guildbanner08'){
                        return "banner_eight";
                    }
                    else if( this.banner.shapeId === 'guildbanner09'){
                        return "banner_nine";
                    }
                    else if( this.banner.shapeId === 'guildbanner10'){
                        return "banner_ten";
                    }
                    else {
                        return "banner_one"; /* default */
                    }
                }
            },
            iconName: {
                get: function() {
                    if( this.banner.symbolId === 'guildicon10' ) {
                        return "icon_one";
                    }
                    else if( this.banner.symbolId === 'guildicon07'){
                        return "icon_two";
                    }
                    else if( this.banner.symbolId === 'guildicon01'){
                        return "icon_three";
                    }
                    else if( this.banner.symbolId === 'guildicon04'){
                        return "icon_four";
                    }
                    else if( this.banner.symbolId === 'guildicon03'){
                        return "icon_five";
                    }
                    else if( this.banner.symbolId === 'guildicon09'){
                        return "icon_six";
                    }
                    else if( this.banner.symbolId === 'guildicon02'){
                        return "icon_seven";
                    }
                    else if( this.banner.symbolId === 'guildicon05'){
                        return "icon_eight";
                    }
                    else if( this.banner.symbolId === 'guildicon06'){
                        return "icon_nine";
                    }
                    else if( this.banner.symbolId === 'guildicon08'){
                        return "icon_ten";
                    }
                    else {
                        return "icon_one"; /* default */
                    }
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .icon_one   { background-position: 0% !important; }             /* guildicon10 */
    .icon_two   { background-position: 11.1% !important; }          /* guildicon07 */
    .icon_three { background-position: 22.1% !important; }          /* guildicon01 */
    .icon_four  { background-position: 33.2% !important; }          /* guildicon04 */
    .icon_five  { background-position: 44.6% !important; }          /* guildicon03 */
    .icon_six   { background-position: 55.6% !important; }          /* guildicon09 */
    .icon_seven { background-position: 66.7% !important; }          /* guildicon02 */
    .icon_eight { background-position: 77.9% !important; }          /* guildicon05 */
    .icon_nine  { background-position: 88.9% !important; }          /* guildicon06 */
    .icon_ten   { background-position: 99.99% !important; }         /* guildicon08 */

    .banner_one   { background-position: 0% !important;     }       /* guildbanner01 */
    .banner_two   { background-position: 11% !important;    }       /* guildbanner02 */
    .banner_three { background-position: 22.1% !important;  }       /* guildbanner03 */
    .banner_four  { background-position: 33.2% !important;  }       /* guildbanner04 */
    .banner_five  { background-position: 44.3% !important;  }       /* guildbanner05 */
    .banner_six   { background-position: 55.4% !important;  }       /* guildbanner06 */
    .banner_seven { background-position: 66.55% !important; }       /* guildbanner07 */
    .banner_eight { background-position: 77.7% !important;  }       /* guildbanner08 */
    .banner_nine  { background-position: 88.8% !important;  }       /* guildbanner09 */
    .banner_ten   { background-position: 99.87% !important; }       /* guildbanner10 */

    .banner_black  { filter: brightness(28%) sepia(0) saturate(5) hue-rotate(180deg);   } /* 4802889  */
    .banner_grey   { }                                                                    /* 16777215 */
    .banner_green  { filter: brightness(45%) sepia(100) saturate(5) hue-rotate(80deg);  } /* 4696116  */
    .banner_gold   { filter: brightness(70%) sepia(100) saturate(5) hue-rotate(10deg);  } /* 16761643 */
    .banner_red    { filter: brightness(18%) sepia(100) saturate(25) hue-rotate(0deg);  } /* 11862016 */
    .banner_orange { filter: brightness(45%) sepia(100) saturate(5) hue-rotate(350deg); } /* 14641694 */
    .banner_cyan   { filter: brightness(48%) sepia(100) saturate(5) hue-rotate(160deg); } /* 5744869  */
    .banner_blue   { filter: brightness(28%) sepia(100) saturate(5) hue-rotate(190deg); } /* 869548   */
    .banner_purple { filter: brightness(40%) sepia(100) saturate(5) hue-rotate(230deg); } /* 9131719  */
    .banner_violet { filter: brightness(45%) sepia(100) saturate(5) hue-rotate(265deg); } /* 15025865 */

    .clippy {
        clip: rect(0px 120px 120px 0px);
    }

    .sprite_wrapper {
        position:relative;
        float:left;
        clear:none;
        overflow:hidden;
        display:block;
        /* height:75px; */  /* change height and width to adjust overall banner size */
        /* width:75px;  */
    }


    .pole_div {
        position:absolute;
        top:0;
        left:0;
        background: url(/static/img/guild-banner/pole.png) no-repeat;
        background-color: transparent;
        display:block;
        padding-bottom:100%;
        padding-left:100%;
        max-height:120px;
        max-width:120px;
        background-size:100%;
        z-index:1;
    }

    .banner_div {
        position:absolute;
        top:0;
        left:0;
        background: url(/static/img/guild-banner/banners.png) no-repeat;
        background-color: transparent;
        height:100%;
        width:100%;
        display:block;
        z-index:10;
        background-size:1000%;
    }

    .icon_div {
        position:absolute;
        top:0;
        left:0;
        background: url(/static/img/guild-banner/icons.png) no-repeat;
        background-color: transparent;
        height:100%;
        width:100%;
        display:block;
        z-index:20;
        background-size:1000%;
    }

</style>



// WEBPACK FOOTER //
// src/components/ElvBannerIcon.vue